import { FC } from "react";
import {
  WaterMeasurementProtocolStatus,
  waterMeasurementProtocolStatusLabel,
} from "types/waterMeasurementProtocol/waterMeasurementProtocol.helpers";
import { cn } from "helpers/classNames";

interface Props {
  status: WaterMeasurementProtocolStatus;
  className?: string;
}

const containerBaseClass =
  "inline-flex items-center gap-x-0.5 rounded-md pl-1.5 pr-2 py-1 text-xs font-medium ring-1 ring-inset";

const getContainerClass = (status: WaterMeasurementProtocolStatus) =>
  status === WaterMeasurementProtocolStatus.ReportCompiled
    ? "bg-cyan-50 text-cyan-900 ring-cyan-600/20"
    : "bg-yellow-50 text-yellow-900 ring-yellow-600/20";

export const WaterMeasurementStatusTag: FC<Props> = ({ status, className }) => (
  <span
    className={cn(containerBaseClass, getContainerClass(status), className)}
  >
    {waterMeasurementProtocolStatusLabel(status)}
  </span>
);
